/**
 * Returns the next photo index, clamped to [0, total-1].
 * If current is the last photo, returns current (stays at last).
 */
export function getNextIndex(current: number, total: number): number {
  if (total <= 0) return 0;
  return Math.min(current + 1, total - 1);
}

/**
 * Returns the previous photo index, clamped to [0, total-1].
 * If current is the first photo, returns 0 (stays at first).
 */
export function getPrevIndex(current: number, total: number): number {
  if (total <= 0) return 0;
  return Math.max(current - 1, 0);
}
